var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0156 33.2383H23.0156V29.2383H27.0156V33.2383ZM39.0156 33.2383H31.0156V29.2383H39.0156V33.2383ZM19.0156 25.2383H15.0156V21.2383H19.0156V25.2383ZM39.0156 25.2383H23.0156V21.2383H39.0156V25.2383ZM43.0156 43.2383H11.0156C9.95476 43.2383 8.93734 42.8169 8.1872 42.0667C7.43705 41.3166 7.01563 40.2991 7.01562 39.2383V15.2383C7.01562 14.1774 7.43705 13.16 8.1872 12.4099C8.93734 11.6597 9.95476 11.2383 11.0156 11.2383H43.0156C44.0765 11.2383 45.0939 11.6597 45.8441 12.4099C46.5942 13.16 47.0156 14.1774 47.0156 15.2383V39.2383C47.0156 40.2991 46.5942 41.3166 45.8441 42.0667C45.0939 42.8169 44.0765 43.2383 43.0156 43.2383ZM11.0156 15.2383V39.2383H43.0156V15.2383H11.0156Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCard);
export default __webpack_public_path__ + "static/media/Feature_Card.3ebd730763bcabc8e1307b073fbe1228.svg";
export { ForwardRef as ReactComponent };